export default __webpack_public_path__ + "static/media/paver-driveway.a85a5c25.jpg";